import { DragOverlay } from '../adapters/dndAdapter';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * DragOverlayWrapper - Overlay que muestra el elemento durante el arrastre
 *
 * Proporciona una preview visual del item siendo arrastrado
 * El overlay sigue el cursor y se renderiza fuera del flujo normal del DOM
 *
 * @param {string|number|null} activeId - ID del elemento siendo arrastrado
 * @param {Function} renderItem - Función que renderiza el overlay dado el activeId
 * @param {string} [className] - Clase CSS adicional
 * @param {boolean} [dropAnimation=true] - Animar al soltar
 * @param {number} [zIndex=1000] - z-index del overlay
 * @param {Array} [modifiers] - Modificadores de posición (@dnd-kit/modifiers)
 * @param {Object} [style] - Estilos del contenedor; `height: 'auto'` evita que herede la altura del elemento original
 */
const DragOverlayWrapper = ({ activeId, renderItem, className, dropAnimation = true, zIndex = 1000, modifiers, style }) => {
  const dropAnimationConfig = dropAnimation
    ? {
        duration: 250,
        easing: 'ease',
      }
    : null;

  return (
    <DragOverlay dropAnimation={dropAnimationConfig} modifiers={modifiers} zIndex={zIndex} className={className} style={{ cursor: 'grabbing', ...style }}>
      {activeId ? renderItem(activeId) : null}
    </DragOverlay>
  );
};

DragOverlayWrapper.propTypes = {
  activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderItem: PropTypes.func.isRequired,
  className: PropTypes.string,
  dropAnimation: PropTypes.bool,
  zIndex: PropTypes.number,
  modifiers: PropTypes.array,
  style: PropTypes.object,
};

export default DragOverlayWrapper;
